var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEssaySmartTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 53,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M41.667 28.872 33 20.205M13.5 5.038 12.16 7.716c-.575 1.15-.862 1.725-1.247 2.224a6.504 6.504 0 0 1-1.18 1.18c-.498.384-1.073.671-2.224 1.247l-2.677 1.338 2.677 1.339c1.15.575 1.726.862 2.225 1.247.442.34.838.737 1.18 1.18.384.498.671 1.073 1.246 2.224l1.339 2.677 1.338-2.677c.576-1.15.863-1.726 1.248-2.224a6.504 6.504 0 0 1 1.18-1.18c.498-.385 1.073-.672 2.224-1.247l2.677-1.339-2.678-1.338c-1.15-.576-1.725-.863-2.224-1.248a6.504 6.504 0 0 1-1.18-1.18c-.384-.498-.671-1.073-1.247-2.223L13.5 5.038Zm1.083 42.25 7.333-.814c.896-.1 1.344-.15 1.763-.285.371-.12.725-.29 1.05-.505.368-.242.687-.561 1.324-1.199L46 24.538a6.128 6.128 0 0 0-8.667-8.666L17.386 35.819c-.637.637-.956.956-1.198 1.323-.215.326-.385.68-.505 1.051-.136.419-.185.867-.285 1.763l-.815 7.332Z",
  stroke: "url(#essay-smart-tool_svg__a)",
  strokeWidth: 4.34,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "essay-smart-tool_svg__a",
  x1: 47.795,
  y1: 26.163,
  x2: 4.833,
  y2: 26.163,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC7600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D66300"
})))));
export default SvgEssaySmartTool;